module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "selectSch"
    }
  }, [(_vm.canUse) ? _c('el-form-item', {
    attrs: {
      "label": "适用学校：",
      "prop": "schObj.applicableCampus"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": _vm.disabled,
      "label": "0"
    },
    model: {
      value: (_vm.schObj.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.schObj, "applicableCampus", $$v)
      },
      expression: "schObj.applicableCampus"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.disabled,
      "label": "1"
    },
    model: {
      value: (_vm.schObj.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.schObj, "applicableCampus", $$v)
      },
      expression: "schObj.applicableCampus"
    }
  }, [_vm._v("部分")])], 1) : _vm._e(), _vm._v(" "), (!_vm.canUse) ? _c('el-form-item', {
    attrs: {
      "label": "适用学校：",
      "prop": "schObj.applicableCampus"
    }
  }, [(_vm.schObj.applicableCampus == '0') ? _c('el-radio', {
    attrs: {
      "disabled": _vm.disabled,
      "label": "0",
      "disabled": ""
    },
    model: {
      value: (_vm.schObj.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.schObj, "applicableCampus", $$v)
      },
      expression: "schObj.applicableCampus"
    }
  }, [_vm._v("全部")]) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus == '1') ? _c('el-radio', {
    attrs: {
      "disabled": _vm.disabled,
      "label": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.schObj.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.schObj, "applicableCampus", $$v)
      },
      expression: "schObj.applicableCampus"
    }
  }, [_vm._v("部分")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus == '0') ? _c('el-form-item', {
    attrs: {
      "label": "屏蔽学校："
    }
  }, [(_vm.schObj.applicableCampus == '0' && _vm.canUse) ? _c('el-select', {
    staticClass: "inline",
    attrs: {
      "disabled": _vm.disabled,
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.campus),
      callback: function($$v) {
        _vm.campus = $$v
      },
      expression: "campus"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.rootUnid,
        "label": item.name
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus === '0' && _vm.canUse) ? _c('el-button', {
    staticClass: "inline",
    attrs: {
      "disabled": _vm.disabled,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addCamp(0)
      }
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus === '0') ? _c('div', {
    staticClass: "campContain",
    style: ({
      'pointer-events': _vm.disabled ? 'none' : ''
    })
  }, _vm._l((_vm.schObj.shieldedSchools), function(item, index) {
    return (item.name) ? _c('span', {
      key: index,
      staticClass: "campSpan"
    }, [_vm._v(_vm._s(item.name) + "\n        "), (_vm.canUse) ? _c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.deleteShieldedCamp(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("一共 " + _vm._s(_vm.schObj.shieldedSchools.length) + " 所学校")])], 1) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus == '1') ? _c('el-form-item', {
    attrs: {
      "label": "应用学校：",
      "required": ""
    }
  }, [(_vm.schObj.applicableCampus == '1' && _vm.canUse) ? _c('el-select', {
    staticClass: "inline",
    attrs: {
      "disabled": _vm.disabled,
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.campus),
      callback: function($$v) {
        _vm.campus = $$v
      },
      expression: "campus"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.rootUnid !== 0) ? _c('el-option', {
      key: index,
      attrs: {
        "value": item.rootUnid,
        "label": item.name
      }
    }) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus === '1' && _vm.canUse) ? _c('el-button', {
    staticClass: "inline",
    attrs: {
      "disabled": _vm.disabled,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addCamp(1)
      }
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.schObj.applicableCampus === '1') ? _c('div', {
    staticClass: "campContain",
    style: ({
      'pointer-events': _vm.disabled ? 'none' : ''
    })
  }, _vm._l((_vm.schObj.openedSchools), function(item, index) {
    return (item.name) ? _c('span', {
      key: index,
      staticClass: "campSpan"
    }, [_vm._v(_vm._s(item.name) + "\n        "), (_vm.canUse) ? _c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.deleteOpenedCamp(index)
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("一共 " + _vm._s(_vm.schObj.openedSchools.length) + " 所学校")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cb454bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/selectSch.vue
// module id = 1063
// module chunks = 0